<template>
  <div v-if="data !== null">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <Pagination :numberOfDots="5" :numberOfVisitedDots="4" />
          <div class="clearfix"></div>
          <div class="header-wrapper">
            <h2 class="text-primary-fh" v-html="data.screening.cholesterolvaluesheader"></h2>
          </div>
          <div class="clearfix"></div>
          <p v-html="data.screening.cholesterolvaluestext"></p>
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <!-- MedicineList -->
          <div class="card" v-for="(c, i) in data.misc.cholesterollist" v-bind:key="c">
            <h5 class="text-light" data-toggle="collapse" :data-target="'#card-' + c" >
              {{ c }} <span class="text-danger" v-if="c === 'LDL-kolestrol'">*</span>
            </h5>
            <div class="collapse" v-bind:id="'card-' + c">
                <div class="input-group">
                    <input
                      type="number"
                      class="form-control form-control-lg"
                      v-model="cols[i].measurement"
                      placeholder="mmol/l"
                      :disabled="noResults"
                    />
                </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="btn-group-toggle">
            <label
              class="btn btn-primary btn-lg btn-block checkbox-btn"
              :class="noResults ? 'active': false">
              <input
                type="checkbox"
                v-model="noResults"
                v-bind:value="true"
                autocomplete="off">
              Ej tillgängligt
            </label>
          </div>
          <div class="clearfix"></div>
          <button
            class="btn btn-primary btn-lg btn-block"
            :disabled="(!colsIncomplete() && !noResults)"
            @click="verifyCols()">
            Nästa
          </button>
          <div class="clearfix"></div>
          <small class="pull-left"><span class="text-danger font-weight-bold">*)</span> Viktigast</small>
          <br />
          <small class="pull-left">Tryck nästa för att gå vidare.</small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import { request } from '../plugins/datocms'

export default {
  name: 'screeningcolvals',
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null,
      cols: [
        {
          name: 'LDL-kolesterol',
          measurement: null,
          unit: 'mmol/l'
        },
        {
          name: 'HDL-kolesterol',
          measurement: null,
          unit: 'mmol/l'
        },
        {
          name: 'Triglycerider',
          measurement: null,
          unit: 'mmol/l'
        }
      ],
      noResults: false
    }
  },
  methods: {
    colsIncomplete () {
      for (let i = 0; i < this.cols.length; i++) {
        const col = this.cols[i]
        if (col.measurement) {
          return true
        }
        return false
      }
    },
    verifyCols () {
      let loader = this.$loading.show()
      var answer = null
      if (this.noResults) {
        answer = {
          question: 'Fyll i kolesterolvärden från ditt senaste prov',
          cholesterol: 'Resultat ej tillgängligt'
        }
      } else {
        answer = {
          question: 'Fyll i kolesterolvärden från ditt senaste prov',
          cholesterol: this.cols
        }
      }
      sessionStorage.setItem('cols', JSON.stringify(answer)) // Pass to next route
      loader.hide()
      this.$router.push('screeningcoltime')
    }
  },
  watch: {
    noResults (res) {
      if (res) {
        this.cols.forEach(c => {
          c.measurement = null
        })
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          screening {
            cholesterolvaluesheader
            cholesterolvaluestext
          }
          misc {
            cholesterollist
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 110px;
  margin-bottom: 50px;
  min-height: 60vh;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button,
select {
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
}
::-webkit-input-placeholder {
  text-align: right;
}
.measure-unit-form-control {
  max-width: 125px;
  color: #6c7592;
  cursor: pointer;
}
@media screen and (min-width: 800px) {
  .header-wrapper {
    display: flex;
  }
}
.pull-left {
  float: left !important;
}
.dropdown-toggle:after {
  content: none;
}
select { text-align-last: right; }
option { direction: rtl; }
.card {
  border: 2px solid #069ccc;
  padding: 15px;
  margin-bottom: 10px;
  background: #59c5e8;
}
.card-body {
  display: none;
}
.expanded-h5 {
  color: #fff !important;
}
.card h5 {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ScreeningCholesterolExt.vue